import { Controller } from '@hotwired/stimulus'

export default class PlanInvestmentController extends Controller {
  static targets = [
    'amountInput',
    'hiddenAmountInput',
    'submitButton',
    'subscriptionForm',
    'successMessageContainer',
    'successModal',
    'createModal',
  ];

  static values = {
    errorMessage: String,
    notEnoughMoneyModalId: String,
  }

  checkAmountAndOpenCreateModal() {
    if (this.subscriptionFormTarget.reportValidity()) {
      const amount = this.amountInputTarget.value;
      const prefixLabel = this.submitButtonTarget.dataset.prefixLabel;

      const formattedAmount = new Intl.NumberFormat(
        'fr-FR',
        { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }
      ).format(amount)

      this.hiddenAmountInputTarget.value = amount;
      this.submitButtonTarget.value = `${prefixLabel} ${formattedAmount}`;
      this.submitButtonTarget.textContent = this.submitButtonTarget.value;

      this.openCreateModal();
    }
  }

  openCreateModal() {
    (new bootstrap.Modal(`#${this.createModalTarget.id}`)).show();
  }

  openEditModal(event) {
    (new bootstrap.Modal(`#${event.target.dataset.modalId}`)).show();
  }

  openCancelModal(event) {
    (new bootstrap.Modal(`#${event.target.dataset.modalId}`)).show();
  }

  async submitCreateForm(event) {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);

    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        this.successMessageContainerTarget.innerHTML = result.success_message_html;
        (new bootstrap.Modal(`#${this.successModalTarget.id}`)).show();
      } else if (result.already_exists_for_project) {
        window.location.reload();
      } else if (result.insufficient_funds) {
        (new bootstrap.Modal(`#${this.notEnoughMoneyModalIdValue}`)).show();
      } else {
        console.error(response);
        toastr.error(result.errors ? result.errors : this.errorMessageValue);
      }
    } catch (error) {
      console.error(error);
      toastr.error(this.errorMessageValue);
    }
  }

  async submitUpdateForm(event) {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);

    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        this.successMessageContainerTarget.innerHTML = result.success_message_html;
        (new bootstrap.Modal(`#${this.successModalTarget.id}`)).show();
      } else if (result.insufficient_funds) {
        (new bootstrap.Modal(`#${this.notEnoughMoneyModalIdValue}`)).show();
      } else {
        console.error(response);
        toastr.error(result.errors ? result.errors : this.errorMessageValue);
      }
    } catch (error) {
      console.error(error);
      toastr.error(this.errorMessageValue);
    }
  }

  async submitCancelForm(event) {
    event.preventDefault();

    const form = event.target;
    const formData = new FormData(form);

    try {
      const response = await fetch(form.action, {
        method: form.method,
        body: formData
      });

      if (response.ok) {
        window.location.reload();
      } else {
        console.error(response);
        toastr.error(this.errorMessageValue);
      }
    } catch (error) {
      console.error(error);
      toastr.error(this.errorMessageValue);
    }
  }

  reloadPage() {
    window.location.reload();
  }
}
